import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { GetOrderImportsInput } from './GetOrderImportsInput';
import { GetOrderImportsOutput } from './GetOrderImportsOutput';

export class GetOrderImportsService extends HttpServiceBase {

    handle = (input?: GetOrderImportsInput): Promise<Result<GetOrderImportsOutput>|null> => {
        const parameters = input ? this.objectToUrl(input) : '';
        const promise = this.http.get<Result<GetOrderImportsOutput>>(`${this.baseUrlSislogApi}/v2/order-import${parameters}`);
        return promise;
    }
}